import application_settings from '../applicationSettings';
import Event from './Event';

class ClearFavoriteList extends Event {
    eventName = 'oms_clearFavoriteListEvent';

    constructor() {
        super();
        this.add();
    }

    eventFunction(data) {
        let clientId = data.client_id;
        let thisObj = this;
        let requestId = (data.request_id) ? data.request_id : '';
        let action = (data.action) ? data.action : '';

        // request data
        data.endPoint = application_settings.endPoints.ClearFavoriteList;
        data.method = 'POST';
        data.canUsePublicAuth = false;
        data.data = {
            location_id: data?.locationId,
        };
        // send request
        this.sendRequest(data, function (response) {
            if (response) {
            //format response data
            let data = thisObj.formatResponseData(response);

            //fire success event
            thisObj.onSuccessEvent(data, {'action' : action, 'request_id' : requestId });
            }
        });
    }
}

export default ClearFavoriteList;